import request from '@/util/request';

export const getList = (current, size, params) => {
  return request({
    url: '/api/v4ward/url/page',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    },
  });
};

export const getDetail = (id) => {
  return request({
    url: '/api/v4ward/url/detail',
    method: 'get',
    params: {
      id,
    },
  });
};

export const remove = (ids) => {
  return request({
    url: '/api/v4ward/url/remove',
    method: 'post',
    params: {
      ids,
    },
  });
};

export const add = (row) => {
  return request({
    url: '/api/v4ward/url/submit',
    method: 'post',
    data: row,
  });
};

export const update = (row) => {
  return request({
    url: '/api/v4ward/url/submit',
    method: 'post',
    data: row,
  });
};
